import { createAction, lt, showErrorAlert } from '@mews/framework';
import { createUUID } from '@mews/std';
import { CommanderThunkAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { getStubMessage } from '../selectors/utils';
import {
    MESSAGE_DRAFT_UPDATED,
    MESSAGE_ADDED,
    MESSAGE_UPDATED,
    MESSAGE_REMOVED,
    MESSAGES_FETCHING,
} from '../actionTypes';
import { fetchThreadsMessages } from './threadsApi';
import { removeThread } from './utils';

export function messageDraftUpdated(threadId: $TSFixMe, text: $TSFixMe) {
    return createAction(MESSAGE_DRAFT_UPDATED, { threadId, text });
}

export const fetchMessages = (threadId: $TSFixMe) => (dispatch: $TSFixMe) => {
    const promise = dispatch(fetchThreadsMessages([threadId]));
    return dispatch(createFetchAction(MESSAGES_FETCHING, promise, { id: threadId })).then(() =>
        dispatch(removeThread(threadId))
    );
};

export const sendMessage =
    (threadId: string, text: string): CommanderThunkAction =>
    (dispatch, getState, { appClockService }) => {
        const stubMessage = getStubMessage(getState());
        const messageId = createUUID();
        const createdUtc = appClockService.getAppNowUtc().value;

        const message = { ...stubMessage, id: messageId, text, createdUtc };

        dispatch(addStubMessage(threadId, message));
        return dispatch(postMessage(threadId, messageId, text));
    };

export function addStubMessage(threadId: $TSFixMe, message: $TSFixMe) {
    return (dispatch: $TSFixMe) => {
        dispatch(messageDraftUpdated(threadId, ''));
        return dispatch(createAction(MESSAGE_ADDED, { threadId, message }));
    };
}

export function postMessage(threadId: $TSFixMe, messageId: $TSFixMe, text: $TSFixMe) {
    return (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) =>
        container()
            .messageComponent.add(threadId, text)
            .then(() => {
                dispatch(fetchMessages(threadId)).then(() => dispatch(removeMessage(threadId, messageId)));
            })
            .catch((error: $TSFixMe) => {
                const description = error?.message ? <>{error.message}</> : lt('MessageSendFailedErrorMessage');
                showErrorAlert({ description });
                dispatch(updateMessage(threadId, messageId, { isFailed: true }));
                throw error;
            });
}

export function updateMessage(threadId: $TSFixMe, messageId: $TSFixMe, data: $TSFixMe) {
    return createAction(MESSAGE_UPDATED, { threadId, messageId, data });
}

export function removeMessage(threadId: $TSFixMe, messageId: $TSFixMe) {
    return createAction(MESSAGE_REMOVED, { threadId, messageId });
}
